/*!

=========================================================
* Paper Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react"
import SweetAlert from "react-bootstrap-sweetalert";
import defaultImage from "assets/img/image_placeholder.jpg";
import ReactDatetime from "react-datetime";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Label,
  Row,
  Col,
  FormText,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";

//import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import ImageUpload from "components/CustomUpload/ImageUploadControlled.jsx";
import * as utils from "components/Utilities/utilities.js";
import { firebase, fs, store } from "components/Firebase/firebase.js";
import ReactTable from "react-table";
import { number } from "prop-types";

import { stringifyTimeStamp } from "components/Utilities/utilities.js";
import {
  validateEmail,
  validateSin,
  getCurrentDate,
} from "components/Utilities/utilities.js";
import { toLowerCase, toUpperCase } from "components/Utilities/allUserUtilities";

class ApplicantProfile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      //setting states for profile data
      firstName: "",
      lastName: "",
      dob: "",
      age: "",
      gender: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      province: "",
      postalCode: "",
      sin: "",
      completedTraining: [],
      originalTrainingStatus: {},
      legallyWork: "",
      availability: [
        {
          // 0: Monday
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          active: false,
          m: false,
          a: false,
          n: false,
        },
        {
          // 6: Sunday
          active: false,
          m: false,
          a: false,
          n: false,
        },
      ],
      emergencyFirstName: "",
      emergencyLastName: "",
      emergencyPhone: "",
      emergencyRelationship: "",

      //filling in user history tables
      chequeNotPickedUp: [],
      chequePickedUp: [],
      changeLog: [],
      commentHistory: [],
      addComment: "",
      errorAddComment: "",
      trainingHistory: [],

      //misc states
      docId: "",
      HSId: number,
      isLoading: false,
      pageTabs: "editProfile",
      showWorkPermit: false,
      showStudentVisa: false,
      trainingChange: "",
      hasTrainingHistory: null,

      //error handling
      errorFirstName: "",
      errorLastName: "",
      errorPinNumber: "",
      errorBadgeNumber: "",
      errorAvailability: "",
      errorGender: "",
      errorDob: "",
      errorPhone: "",
      errorEmail: "",
      errorAddress: "",
      errorCity: "",
      errorProvince: "",
      errorPostalCode: "",
      errorSin: "",
      errorTempCompletedTraining: "",
      errorLegallyWork: "",
      errorWorkStatus: "",
      errorEmergencyFirstName: "",
      errorEmergencyLastName: "",
      errorEmergencyPhone: "",
      errorEmergencyRelationship: "",

      //images!
      images: [],
      imagesUrl: {},
      signature: null,
      localImages: [
        {
          file: null,
          imagePreviewUrl: defaultImage,
        },
        {
          file: null,
          imagePreviewUrl: defaultImage,
        },
        {
          file: null,
          imagePreviewUrl: defaultImage,
        },
        {
          file: null,
          imagePreviewUrl: defaultImage,
        }
      ],
    };
  }

  componentDidMount() {
    this.applicantDataRef = fs.collection("applicant_data")
    this.fileStorageRef = firebase.storage().ref("applicant_files")
    this.trainingDataRef = fs.collection("training_data");
    this.loadUsers();
    this.loadImages();
    //window.addEventListener("beforeunload", this.handleUserLeave);//popup warning if user reloads or closes the page
  }

  componentWillUnmount() {
    //window.removeEventListener("beforeunload", this.handleUserLeave);
  }

  handleUserLeave = (e) => {
    const confirmationMessage = "Data would be sent if you leave the page";
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  };

  handleSubmit = () => {
    this.setState({ isLoading: true });
    let tempState = this.state; // Copy of state
    let hasError = false;

    // Start of Error Handling
    if (tempState.firstName === null || tempState.firstName === "") {
      this.setState({ errorFirstName: "* Must have a first name." });
      hasError = true;
    } else {
      this.setState({ errorFirstName: "" });
    }

    if (tempState.lastName === null || tempState.lastName === "") {
      this.setState({ errorLastName: "* Must have a last name." });
      hasError = true;
    } else {
      this.setState({ errorLastName: "" });
    }

    if (
      tempState.availability[0].active === false &&
      tempState.availability[1].active === false &&
      tempState.availability[2].active === false &&
      tempState.availability[3].active === false &&
      tempState.availability[4].active === false &&
      tempState.availability[5].active === false &&
      tempState.availability[6].active === false
    ) {
      hasError = true;
      this.setState({
        errorAvailability: "* Must have at least 1 day available for work.",
      });
    } else {
      this.setState({ errorAvailability: "" });
    }
    // optional fields no need of error handling
    // if (tempState.pinNumber === null || tempState.pinNumber === undefined) {
    //   this.setState({ pinNumber: "" }); //No pin number
    // }

    // if (tempState.badgeNumber === null || tempState.badgeNumber === undefined ) {
    //   this.setState({ badgeNumber: "" }); //No badge number
    // } 

    if (tempState.gender === null || tempState.gender === "") {
      this.setState({ errorGender: "* Must select a gender." });
      hasError = true;
    } else {
      this.setState({ errorGender: "" });
    }

    if (!tempState.dob) {
      this.setState({ errorDob: "* Must have date of birth." });
      hasError = true;
    } else if (new Date().getYear() - new Date(tempState.dob._d).getYear() < 18) {
      this.setState({ errorDob: "* Must be 18 or older." });
      hasError = true;
    } else {
      this.setState({ errorDob: "" });
    }

    if (tempState.phone === null || tempState.phone === "") {
      this.setState({ errorPhone: "* Must have a phone number." }); // No phone number
      hasError = true;
    } else {
      if (
        isNaN(tempState.phone) === true ||
        tempState.phone.length != 10 ||
        tempState.phone < 0
      ) {
        this.setState({ errorPhone: "* Please input a valid phone number." }); //invalid phone number
        hasError = true;
      } else {
        this.setState({ errorPhone: "" });
      }
    }

    if (tempState.email === null || tempState.email === "") {
      this.setState({ errorEmail: "* Must have an email" }); // No email text
    } else {
      if (tempState.email != null && validateEmail(tempState.email) === false) {
        this.setState({ errorEmail: "* Please input a valid email" }); //invalid email text
        hasError = true;
      } else {
        this.setState({ errorEmail: "" });
      }
    }

    if (tempState.address === null || tempState.address === "") {
      this.setState({ errorAddress: "* Must have a street address." });
      hasError = true;
    } else {
      this.setState({ errorAddress: "" });
    }

    if (tempState.licenseNumber === null || tempState.licenseNumber === "") {
      this.setState({ errorLicenseNumber: "* Must have a license number." });
      hasError = true;
    } else {
      this.setState({ errorLicenseNumber: "" });
    }

    if (tempState.city === null || tempState.city === "") {
      this.setState({ errorCity: "* Must have a city." });
      hasError = true;
    } else {
      this.setState({ errorCity: "" });
    }

    if (tempState.province === null || tempState.province === "") {
      this.setState({ errorProvince: "* Must have a province." });
      hasError = true;
    } else {
      this.setState({ errorProvince: "" });
    }

    if (tempState.postalCode === null || tempState.postalCode === "") {
      this.setState({ errorPostalCode: "* Must have a postal code." });
      hasError = true;
    } else {
      let regExp = "^([A-Z]|[a-z])[0-9]([A-Z]|[a-z])[0-9]([A-Z]|[a-z])[0-9]$"; //logic for postal code format A1B2C3, accepts any case letters
      if (tempState.postalCode.match(regExp) === null || tempState.postalCode.length != 6) {
        this.setState({
          errorPostalCode: "* Please input a valid postal code.",
        }); //invalid postal code
        hasError = true;
      } else {
        this.setState({ errorPostalCode: "" });
      }
    }

    if (tempState.sin === null || tempState.sin === "") {
      this.setState({ errorSin: "* Must have a SIN." }); //No sin
      hasError = true;
    } else {
      if (validateSin(tempState.sin) === false) {
        this.setState({ errorSin: "* Please input a valid SIN." }); //invalid sin
        hasError = true;
      } else {
        this.setState({ errorSin: "" });
      }
    }

    if (tempState.legallyWork === null || tempState.legallyWork === "") {
      this.setState({ errorLegallyWork: "* Must select yes or no." });
      hasError = true;
    } else {
      this.setState({ errorLegallyWork: "" });
    }

    if (tempState.emergencyFirstName === null || tempState.emergencyFirstName === "") {
      this.setState({
        errorEmergencyFirstName:
          "* Must have a first name for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyFirstName: "" });
    }

    if (tempState.emergencyLastName === null || tempState.emergencyLastName === "") {
      this.setState({
        errorEmergencyLastName:
          "* Must have a last name for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyLastName: "" });
    }

    if (tempState.emergencyPhone === null || tempState.emergencyPhone === "") {
      this.setState({
        errorEmergencyPhone:
          "* Must have a phone number for the emergency contact.",
      }); // No phone number
      hasError = true;
    } else {
      if (
        tempState.emergencyPhone.length != 10 ||
        tempState.emergencyPhone < 0
      ) {
        this.setState({
          errorEmergencyPhone:
            "* Please input a valid phone number in the format ###-###-#### for the emergency contact.",
        }); //invalid phone number
        hasError = true;
      } else {
        this.setState({ errorEmergencyPhone: "" });
      }
    }

    if (tempState.emergencyRelationship === null || tempState.emergencyRelationship === "") {
      this.setState({
        errorEmergencyRelationship:
          "* Must have a relationship for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyRelationship: "" });
    }

    if (hasError) {
      this.setState({ isLoading: false });
      return;
    } else {
      this.prepareAndSendDataToServer(this.toLowerCase(tempState)); // runs function after loading is set as true.
      this.setState({ isLoading: false });
    }
  };

  //Convert every obj element to lowercase if it has string
  toLowerCase(obj) {
    let newObj = {};
    for (let prop in obj) {
      if (typeof obj[prop] === "string") {
        newObj[prop] = obj[prop].toLowerCase();
      } else {
        newObj[prop] = obj[prop];
      }
    }
    return newObj;
  }

  prepareAndSendDataToServer = (tempState) => {
    let currentDate = new Date();

    //Upload the changelog into the user history collection! This uploads the admin email, timestamp, and action taken
    let updateLog = this.state.changeLog;

    updateLog.unshift({
      admin: "User Action",
      time: getCurrentDate(),
      action: "Updated User Profile",
    });

    //Prepare data to upload
    let docId = this.state.docId;
    this.applicantDataRef
      .doc(docId)
      .update({
        firstName: tempState.firstName,
        lastName: tempState.lastName,
        availability: tempState.availability,
        gender: tempState.gender,
        dob: new Date(tempState.dob),
        phone: tempState.phone,
        licenseNumber: tempState.licenseNumber,
        email: tempState.email,
        address: tempState.address,
        city: tempState.city,
        province: tempState.province,
        postalCode: tempState.postalCode,
        sin: tempState.sin,
        legallyWork: tempState.legallyWork,
        emergencyFirstName: tempState.emergencyFirstName,
        emergencyLastName: tempState.emergencyLastName,
        emergencyPhone: tempState.emergencyPhone,
        emergencyRelationship: tempState.emergencyRelationship,
        emergencyFirstName2: tempState.emergencyFirstName2,
        emergencyLastName2: tempState.emergencyLastName2,
        emergencyPhon2e: tempState.emergencyPhone2,
        emergencyRelationship2: tempState.emergencyRelationship2,
        updatedDate: currentDate,
      })
      .then(() => {
        this.applicantDataRef.doc(docId).collection("history").doc("main").update({
          changeLog: updateLog,
        });
      })
      .then(() => {
        console.log("successfully saved Data");
        this.setState({
          isLoading: false,
          alert: (
            <SweetAlert
              success
              title="User successfully updated"
              onConfirm={this.hideAlert}
            />
          ),
          changeLog: updateLog,
        });
      })
      .catch((err) => console.warn("Problem while updating user: ", err));
  };

  hideAlert = () => {
    this.setState({
      alert: null,
    });
  };

  loadingOverlay = () => {
    return (
      <SweetAlert
        style={{
          display: "block",
          marginTop: "-100px",
          background: "transparent",
        }}
        title={
          <Spinner color="light" style={{ width: "3rem", height: "3rem" }} />
        }
        onConfirm={this.hideAlert}
        showConfirm={false}
      />
    );
  };

  loadUsers = () => {
    let tempChangeLogArr = [];
    let HSId = parseInt(localStorage.getItem("HSId"))
    this.setState({ HSId: HSId })

    //Use HSId from URL and pull the user with a matching HSId
    this.applicantDataRef
      .where("HSId", "==", HSId)
      .get()
      .then((snapshot) => {
        if (snapshot.empty) {
          console.log("No matching documents.");
          return;
        }

        //setting states for profile data
        snapshot.forEach((doc) => {
          this.setState({ docId: doc.id });
          let data = toUpperCase(doc.data());
          if (data.workStatus.value === "showWorkPermit") {
            this.setState({ showWorkPermit: true });
          } else if (data.workStatus.value === "showStudentVisa") {
            this.setState({ showStudentVisa: true });
          } else if (data.workStatus.value === "showCitizen") {
          } else {
            console.log("no work status detected!");
          }

          this.setState({
            availability: data.availability,
            firstName: data.firstName,
            lastName: data.lastName,
            gender: data.gender,
            email: data.email,
            phone: data.phone,
            licenseNumber: data.licenseNumber,
            address: data.address,
            city: data.city,
            dob: stringifyTimeStamp(data.dob.toDate()),
            province: data.province,
            postalCode: data.postalCode,
            sin: data.sin,
            emergencyFirstName: data.emergencyFirstName,
            emergencyLastName: data.emergencyLastName,
            emergencyPhone: data.emergencyPhone,
            emergencyRelationship: data.emergencyRelationship,
          });

          if (data.legallyWork === true) {
            this.setState({ legallyWork: "Yes" });
          } else {
            this.setState({ legallyWork: "No" });
          }
          if (typeof data.emergencyFirstName2 === 'string') {
            this.setState({ emergencyFirstName2: data.emergencyFirstName2 });
          } else {
            this.setState({ emergencyFirstName2: "" });
          }
          if (typeof data.emergencyLastName2 === 'string') {
            this.setState({ emergencyLastName2: data.emergencyLastName2 });
          } else {
            this.setState({ emergencyLastName2: "" });
          }
          if (typeof data.emergencyPhone2 === 'string') {
            this.setState({ emergencyPhone2: data.emergencyPhone2 });
          } else {
            this.setState({ emergencyPhone2: "" });
          }
          if (typeof data.emergencyRelationship2 === 'string') {
            this.setState({ emergencyRelationship2: data.emergencyRelationship2 });
          } else {
            this.setState({ emergencyRelationship2: "" });
          }

          //setting states for user history
          this.applicantDataRef
            .doc(this.state.docId)
            .collection("history")
            .doc("main")
            .get()
            .then((doc) => {
              if (doc && doc.exists) {
                doc.data().changeLog.find((element) => {
                  tempChangeLogArr.unshift({
                    time: element.time,
                    action: element.action,
                    admin: element.admin,
                  });
                });
                console.log("tempChangeLogArr: ", tempChangeLogArr);
                this.setState({
                  changeLog: tempChangeLogArr,
                });
              } else {
                console.log("no history dectected");
              }
            })
            .catch((err) => {
              console.log("Error getting user history docs", err);
            });
        });
      })
      .catch((err) => {
        console.log("Error getting user data docs", err);
      });
  };

  loadImages = () => {
    let selectedHSId = parseInt(localStorage.getItem("HSId"))
    let imageName = [1, 3, 5, 7]

    imageName.forEach((i) => {
      let u = `${selectedHSId}/${i}` + ".jpeg";
      this.fileStorageRef
        .child(u)
        .getDownloadURL()
        .then((url) => {
          console.log(url);
          let tempState = this.state.localImages;
          let tempImagesUrl = this.state.imagesUrl;

          tempState[i].imagePreviewUrl = url;
          tempImagesUrl[i] = url;

          this.setState({ localImages: tempState, imagesUrl: tempImagesUrl });
        })
        .catch((err) => {
          console.log("Erroring loading images: ", err);
        });
    })

    this.fileStorageRef
      .child(`${selectedHSId}/signature`)
      .getDownloadURL()
      .then((url) => {
        this.setState({ signature: url })
      })
  };

  _renderWorkPermit = () => {
    if (this.state.showWorkPermit === true) {
      return (
        <Row>
          <Label sm="2">* Work Permit</Label>
          <Col sm="4">
            <CardTitle tag="p">* (Front)</CardTitle>
            <ImageUpload
              imageId={this.state.imageId}
              localImage={this.state.localImages[5]}
              index={5}
              handleImages={this.handleImages}
            />
          </Col>
        </Row>
      );
    } else {
      return;
    }
  };

  _renderStudentVisa = () => {
    if (this.state.showStudentVisa === true) {
      return (
        <Row>
          <Label sm="2">* Student Visa</Label>
          <Col sm="4">
            <CardTitle tag="p">* (Front)</CardTitle>
            <ImageUpload
              imageId={this.state.imageId}
              localImage={this.state.localImages[7]}
              index={7}
              handleImages={this.handleImages}
            />
          </Col>
        </Row>
      );
    } else {
      return;
    }
  };

  loadShiftHistory = () => {
    this.applicantDataRef
      .doc(this.state.docId)
      .collection("history")
      .doc("main")
      .get()
      .then((doc) => {
        if (doc && doc.exists) {
          let path = `/admin/user-profile-shift-history/${this.state.HSId}`;
          this.props.history.push(path);
        } else {
          console.log("no history dectected");
        }
      })
      .catch((err) => {
        console.log("Error getting user data docs", err);
      });
  };

  toggleShifts = (MAN, day) => {
    let tempAvailability = this.state.availability;

    MAN === "m"
      ? (tempAvailability[day].m = !tempAvailability[day].m) // m
      : MAN === "a"
        ? (tempAvailability[day].a = !tempAvailability[day].a) // a
        : (tempAvailability[day].n = !tempAvailability[day].n); // n

    this.setState({ availability: tempAvailability });
  };

  // day = number between 0 (monday) to 6 (sunday)
  toggleCheckMark = (day) => {
    let tempAvailability = this.state.availability;
    tempAvailability[day].active = !tempAvailability[day].active;
    this.setState({ availability: tempAvailability });
  };

  updateImagesUrl = (downloadUrl, index) => {
    let tempImagesUrl = this.state.imagesUrl;
    tempImagesUrl[index] = downloadUrl;
    this.setState({ imagesUrl: tempImagesUrl });
  };

  handleImages = (image, index) => {
    console.log(image, index);
    let newImages = this.state.images;
    newImages[index] = image;
    this.setState({ images: newImages });
    let uploadTask = this.fileStorageRef
      .child(`${this.state.HSId}/${index}.jpeg`)
      .put(image);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
      },
      (err) => { },
      () => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log("File available at", downloadURL);
          this.updateImagesUrl(downloadURL, index);
        });
      }
    );
  };

  renderAvailability = (dayOfWeekText, day) => {
    return (
      <Row>
        <Col sm="3">
          <FormGroup check inline>
            <Label check>
              <Input
                type="checkbox"
                checked={this.state.availability[day].active}
                onChange={() => this.toggleCheckMark(day)}
              />
              <span className="form-check-sign" />
              {dayOfWeekText}
            </Label>
          </FormGroup>
        </Col>
        {this.state.availability[day].active ? (
          <>
            <Col sm="9" align="right">
              <FormGroup check inline>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.availability[day].m}
                    onChange={() => this.toggleShifts("m", day)}
                  />
                  <span className="form-check-sign" />
                  Morning
                </Label>
              </FormGroup>

              <FormGroup check inline>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.availability[day].a}
                    onChange={() => this.toggleShifts("a", day)}
                  />
                  <span className="form-check-sign" />
                  Afternoon
                </Label>
              </FormGroup>

              <FormGroup check inline>
                <Label check>
                  <Input
                    type="checkbox"
                    checked={this.state.availability[day].n}
                    onChange={() => this.toggleShifts("n", day)}
                  />
                  <span className="form-check-sign" />
                  Night
                </Label>
              </FormGroup>
            </Col>
          </>
        ) : null}
      </Row>
    );
  };

  disableFutureDates = current => {
    const today = new Date();
    return current.isBefore(today)
  }

  render() {
    return (
      <>
        <div className="content">
          {this.state.isLoading ? (
            this.loadingOverlay()
          ) : (
              <Row>
                <Col lg="2"></Col>
                <Col lg="8">
                  <Card>
                    <CardHeader>
                      <Row>
                        <Col md="8">
                          <CardTitle tag="h4">
                            Welcome to Your Profile!
                          </CardTitle>
                        </Col>
                        <Col md="4" align="right">
                          <Button
                            onClick={() => {
                              localStorage.removeItem("HSId")
                              this.props.history.push(`/`)
                            }}
                          >
                            Logout
                          </Button>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Nav
                        className="nav-pills-primary nav-pills-icons justify-content-center"
                        pills
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            data-toggle="tab"
                            role="tablist"
                            className={
                              this.state.pageTabs === "editProfile" ? "active" : ""
                            }
                            onClick={() =>
                              this.setState({ pageTabs: "editProfile" })
                            }
                          >
                            <i className="now-ui-icons ui-2_settings-90" />
                            Edit Profile
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            data-toggle="tab"
                            role="tablist"
                            className={
                              this.state.pageTabs === "images" ? "active" : ""
                            }
                            onClick={() => this.setState({ pageTabs: "images" })}
                          >
                            <i className="now-ui-icons ui-2_settings-90" />
                          Images and Files
                          </NavLink>
                        </NavItem>
                      </Nav>
                      <TabContent
                        className="tab-space tab-subcategories"
                        activeTab={this.state.pageTabs}
                      >
                        <TabPane tabId="editProfile">
                          <CardHeader>
                            <CardTitle tag="h4">Edit Profile</CardTitle>
                          </CardHeader>
                          <CardBody>
                            <Form>
                              <Row>
                                <Col className="pr-1" md="4">
                                  <FormGroup>
                                    <Label>First Name</Label>
                                    <Input
                                      value={`${this.state.firstName}`}
                                      onChange={(e) =>
                                        this.setState({
                                          firstName: e.target.value,
                                        })
                                      }
                                      placeholder="First Name"
                                      type="text"
                                    />
                                    <FormText color="danger" tag="span">
                                      {this.state.errorFirstName}
                                    </FormText>
                                  </FormGroup>
                                </Col>
                                <Col className="px-1" md="4">
                                  <FormGroup>
                                    <Label>Last Name</Label>
                                    <Input
                                      value={`${this.state.lastName}`}
                                      onChange={(e) =>
                                        this.setState({
                                          lastName: e.target.value,
                                        })
                                      }
                                      placeholder="Last Name"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorLastName}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="4">
                                  <FormGroup>
                                    <Label>License number</Label>
                                    <Input
                                      value={`${this.state.licenseNumber}`}
                                      onChange={(e) =>
                                        this.setState({ licenseNumber: e.target.value })
                                      }
                                      placeholder="licenseNumber"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorLicenseNumber}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="4">
                                  <FormGroup>
                                    <Label>Date of Birth</Label>
                                    <Input
                                      value={`${this.state.dob}`}
                                      onChange={(e) =>
                                        this.setState({ dob: e.target.value })
                                      }
                                      placeholder="Date of Birth"
                                      type="date"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorDob}
                                  </FormText>
                                </Col>
                                <Col className="px-1" md="4">
                                  <FormGroup>
                                    <Label>Street Address</Label>
                                    <Input
                                      value={`${this.state.address}`}
                                      onChange={(e) =>
                                        this.setState({ address: e.target.value })
                                      }
                                      placeholder="Home Address"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorAddress}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="4">
                                  <FormGroup>
                                    <Label>Email address</Label>
                                    <Input
                                      value={`${this.state.email}`}
                                      onChange={(e) =>
                                        this.setState({ email: e.target.value })
                                      }
                                      placeholder="Email"
                                      type="email"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorEmail}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="4">
                                  <FormGroup>
                                    <Label>City</Label>
                                    <Input
                                      value={`${this.state.city}`}
                                      onChange={(e) =>
                                        this.setState({ city: e.target.value })
                                      }
                                      placeholder="City"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorCity}
                                  </FormText>
                                </Col>
                                <Col className="px-1" md="4">
                                  <FormGroup>
                                    <Label>Province</Label>
                                    <Input
                                      value={`${this.state.province}`}
                                      onChange={(e) =>
                                        this.setState({
                                          province: e.target.value,
                                        })
                                      }
                                      placeholder="Province"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorProvince}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="4">
                                  <FormGroup>
                                    <Label>Postal Code</Label>
                                    <Input
                                      value={`${this.state.postalCode}`}
                                      onChange={(e) =>
                                        this.setState({
                                          postalCode: e.target.value,
                                        })
                                      }
                                      maxLength="6"
                                      placeholder="Postal Code"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorPostalCode}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="3">
                                  <FormGroup>
                                    <Label>Social Insurance Number</Label>
                                    <Input
                                      value={`${this.state.sin}`}
                                      onChange={(e) =>
                                        this.setState({ sin: e.target.value })
                                      }
                                      maxLength="9"
                                      placeholder="Social Insurance Number"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorSin}
                                  </FormText>
                                </Col>
                                <Col className="px-1" md="3">
                                  <FormGroup>
                                    <Label>Phone Number</Label>
                                    <Input
                                      value={`${this.state.phone}`}
                                      onChange={(e) =>
                                        this.setState({ phone: e.target.value })
                                      }
                                      maxLength="10"
                                      placeholder="Phone Number"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorPhone}
                                  </FormText>
                                </Col>
                                <Col className="px-1" md="3">
                                  <FormGroup>
                                    <Label>Legal to Work in Canada?</Label>
                                    <Input
                                      value={`${this.state.legallyWork}`}
                                      onChange={(e) =>
                                        this.setState({
                                          legallyWork: e.target.value,
                                        })
                                      }
                                      placeholder="Work Status"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorLegallyWork}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="3">
                                  <FormGroup>
                                    <Label>Gender</Label>
                                    <Input
                                      value={`${this.state.gender}`}
                                      onChange={(e) =>
                                        this.setState({ gender: e.target.value })
                                      }
                                      maxLength="1"
                                      placeholder="Gender"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorGender}
                                  </FormText>
                                </Col>
                              </Row>
                              {/*<Row>
                                <Col sm="6">
                                  <FormGroup>
                                    <Label>Date of Birth</Label>
                                    <ReactDatetime
                                      input={false}
                                      timeFormat={false}
                                      isValidDate={this.disableFutureDates}
                                      value={this.state.dob}
                                      defaultValue={this.state.dob}
                                      onChange={(value) => {
                                        this.setState({
                                          dob: value
                                        })
                                      }}
                                      id="dob"
                                    />
                                    <FormText color="danger" tag="span">
                                      {this.state.errorDob}
                                    </FormText>
                                  </FormGroup>
                                </Col>
                              </Row>*/}
                              <Row>
                                <Col className="pr-1" md="4">
                                  <Label>Availability</Label>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="8" className="checkbox-radios">
                                  {this.renderAvailability("Monday", 0)}
                                  {this.renderAvailability("Tuesday", 1)}
                                  {this.renderAvailability("Wednesday", 2)}
                                  {this.renderAvailability("Thursday", 3)}
                                  {this.renderAvailability("Friday", 4)}
                                  {this.renderAvailability("Saturday", 5)}
                                  {this.renderAvailability("Sunday", 6)}
                                  <FormText color="danger" tag="span">
                                    {this.state.errorAvailability}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 1: First Name</Label>
                                    <Input
                                      value={`${this.state.emergencyFirstName}`}
                                      onChange={(e) =>
                                        this.setState({
                                          emergencyFirstName: e.target.value,
                                        })
                                      }
                                      placeholder="Emergency Contact 1: First Name"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorEmergencyFirstName}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 1: Last Name</Label>
                                    <Input
                                      value={`${this.state.emergencyLastName}`}
                                      onChange={(e) =>
                                        this.setState({
                                          emergencyLastName: e.target.value,
                                        })
                                      }
                                      placeholder="Emergency Contact 1: Last Name"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorEmergencyLastName}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="6">
                                  <FormGroup>
                                    <Label>
                                      Emergency Contact 1: Phone Number
                                  </Label>
                                    <Input
                                      value={`${this.state.emergencyPhone}`}
                                      onChange={(e) =>
                                        this.setState({
                                          emergencyPhone: e.target.value,
                                        })
                                      }
                                      placeholder="Emergency Contact 1: Phone Number"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorEmergencyPhone}
                                  </FormText>
                                </Col>
                                <Col className="pl-1" md="6">
                                  <FormGroup>
                                    <Label>
                                      Emergency Contact 1: Relationship
                                  </Label>
                                    <Input
                                      value={`${this.state.emergencyRelationship}`}
                                      onChange={(e) =>
                                        this.setState({
                                          emergencyRelationship: e.target.value,
                                        })
                                      }
                                      placeholder="Emergency Contact 1: Relationship"
                                      type="text"
                                    />
                                  </FormGroup>
                                  <FormText color="danger" tag="span">
                                    {this.state.errorEmergencyRelationship}
                                  </FormText>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 2: First Name</Label>
                                    <Input
                                      value={`${this.state.emergencyFirstName2}`}
                                      onChange={(e) =>
                                        this.setState({
                                          emergencyFirstName2: e.target.value,
                                        })
                                      }
                                      placeholder="Emergency Contact 2: First Name"
                                      type="text"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col className="pl-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 2: Last Name (Optional)</Label>
                                    <Input
                                      value={`${this.state.emergencyLastName2}`}
                                      onChange={(e) => this.setState({ emergencyLastName2: e.target.value })}
                                      placeholder="Emergency Contact 2: Last Name"
                                      type="text" />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="pr-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 2: Phone Number (Optional)</Label>
                                    <Input
                                      value={`${this.state.emergencyPhone2}`}
                                      onChange={(e) => this.setState({ emergencyPhone2: e.target.value })}
                                      placeholder="Emergency Contact 2: Phone Number"
                                      type="text"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col className="pl-1" md="6">
                                  <FormGroup>
                                    <Label>Emergency Contact 2: Relationship (Optional)</Label>
                                    <Input
                                      value={`${this.state.emergencyRelationship2}`}
                                      onChange={(e) => this.setState({ emergencyRelationship2: e.target.value })}
                                      placeholder="Emergency Contact 2: Relationship"
                                      type="text"
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                            <FormGroup align="right">
                              <Button
                                color="default"
                                outline
                                onClick={() => this.handleSubmit()}
                              >
                                Save Changes
                            </Button>
                            </FormGroup>
                          </CardBody>
                        </TabPane>
                        <TabPane tabId="images">
                          <CardBody>
                            <Row>
                              <Label sm="2">
                                * Government Issued Photo ID (passport or driver's
                                license)
                            </Label>
                              <Col sm="4">
                                <CardTitle tag="p">* (Front)</CardTitle>
                                <ImageUpload
                                  imageId={this.state.imageId}
                                  localImage={this.state.localImages[1]}
                                  index={1}
                                  handleImages={this.handleImages}
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Label sm="2">* Proof of Sin</Label>
                              <Col sm="4">
                                <CardTitle tag="p">* (Front)</CardTitle>
                                <ImageUpload
                                  imageId={this.state.imageId}
                                  localImage={this.state.localImages[3]}
                                  index={3}
                                  handleImages={this.handleImages}
                                />
                              </Col>
                            </Row>
                            {this._renderStudentVisa()}
                            {this._renderWorkPermit()}
                            <Row>
                              <Label sm="2">* Signature</Label>
                              <Col sm="4">
                                <CardTitle tag="p">Electronic Signature</CardTitle>
                                <img
                                  src={this.state.signature}
                                />
                              </Col>
                            </Row>
                          </CardBody>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="2"></Col>
              </Row>
            )}
          {this.state.alert}
        </div>
      </>
    );
  }
}

export default ApplicantProfile;
